<mat-form-field
	[color]="color"
	[appearance]="appearance"
	[floatLabel]="floatLabel"
>
	<mat-label [innerHtml]="label"></mat-label>
	<textarea
		matInput
		[formControl]="_control"
		[placeholder]="placeholder"
		[required]="required"
		type="text"
		cdkTextareaAutosize
		#autosize="cdkTextareaAutosize"
		[cdkAutosizeMinRows]="minRows"
		[cdkAutosizeMaxRows]="maxRows"
	></textarea>
	<mat-hint [innerHtml]="hint ? hint : ''"></mat-hint>
	<mat-error [innerHtml]="error"></mat-error>
	<img *ngIf="valid && validImage" class="valid-tick" [src]="validImage" />
</mat-form-field>
